import React from 'react'
import {Input, Modal, Row, Col, Form, FormGroup, Label} from "reactstrap";

const render_rows = (tog_standard, modal_standard, brand, onChangeInput, updateCurrentBrand) => {
    if(!brand) return "";

    const { name } = brand;

    return (
        <Modal
            size="xl"
            isOpen={modal_standard}
            toggle={tog_standard}
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    Actualizar marca { name }
                </h5>
                <button type="button"
                        onClick={tog_standard}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Form>
                    <Row>
                        <Col sm="4">
                            <FormGroup>
                                <Label htmlFor="name">Name</Label>
                                <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    className="form-control"
                                    defaultValue={ name }
                                    onChange={ e => {onChangeInput(e.target.value)} }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    onClick={tog_standard}
                    className="btn btn-secondary waves-effect"
                    data-dismiss="modal"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    onClick={updateCurrentBrand}
                    className="btn btn-primary waves-effect waves-light"
                    data-dismiss="modal"
                >
                    Actualizar
                </button>
            </div>
        </Modal>
    );
}

const ModalUpdateBrand = ({tog_standard, modal_standard, brand, onChangeInput, updateCurrentBrand}) => (
    render_rows(tog_standard, modal_standard, brand, onChangeInput, updateCurrentBrand)
)

export default ModalUpdateBrand
